window.infowindow = null;
window.eventMap = null;

const initMap = ($el) => {

	// Find marker elements within map.
	let $markers = $el.querySelectorAll('.marker');
	// Create gerenic map.
	let mapArgs = {
		zoom: parseInt($el.dataset.zoom) || 7,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		streetViewControl: false,
		mapTypeControl: false,
		fullscreenControl: false
	};
	var map = new google.maps.Map($el, mapArgs);
	window.eventMap = map;

	// Add markers.
	map.markers = [];
	$markers.forEach((marker) => {
		initMarker(marker, map);
	});

	// Center map based on markers.
	centerMap(map);

	// Close Infowindow when click on Map
	google.maps.event.addListener(map, "click", function (event) {
		window.infowindow.close();
	});

	document.addEventListener('view-toggle-event', function (event) {
		if (event.target.getAttribute('id') == 'viewMap') {
			centerMap(map);
		}
	});

	document.addEventListener('view-toggle-eventv2', function (event) {
		if (event.target.getAttribute('id') == 'viewMap') {
			centerMap(map);
		}
	});


	// Return map instance.
	return map;
}

const initMarker = ($marker, map) => {

	// Get position from marker.
	let lat = $marker.dataset.lat;
	let lng = $marker.dataset.lng;
	let latLng = {
		lat: parseFloat(lat),
		lng: parseFloat(lng)
	};

	// Determina l'icona del marker in base al mondo
	let markerIcon;
	if (rqst.ICON_MAP && rqst.ICON_MAP.includes('sanita')) {
		markerIcon = {
			url: '/wp-content/themes/korian-master-theme/images/map-pin-openday.svg',
			size: new google.maps.Size(37, 53),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(18, 53)
		};
	} else {
		markerIcon = {
			url: rqst.ICON_MAP,
			size: new google.maps.Size(32, 40),
			origin: new google.maps.Point(0, 0)
		};
	}

	// Create marker instance.
	let marker = new google.maps.Marker({
		position: latLng,
		map: map,
		icon: markerIcon,
	});

	// Append to reference for later use.
	map.markers.push(marker);

	// If marker contains HTML, add it to an infoWindow.
	if ($marker.innerHTML != '') {


		// Show info window when marker is clicked.
		google.maps.event.addListener(marker, 'click', function () {

			const activeInfoWindows = document.querySelectorAll('button[title="Chiudi"].gm-ui-hover-effect');
			Array.from(activeInfoWindows).map(item => {
				item.click();
			})

			// Create info window.
			window.infowindow = new google.maps.InfoWindow({
				content: $marker.innerHTML
			});
			window.infowindow.open(map, marker);
		});

	}
}

const centerMap = (map) => {

	// Create map boundaries from all map markers.
	let bounds = new google.maps.LatLngBounds();
	map.markers.forEach(function (marker) {
		bounds.extend({
			lat: marker.position.lat(),
			lng: marker.position.lng()
		});
	});

	// Case: Single marker.
	if (map.markers.length == 1) {
		map.setCenter(bounds.getCenter());

		// Case: Multiple markers.
	} else {
		map.fitBounds(bounds);
	}

}


const EventMap = () => {
	const acfmaps = document.querySelectorAll(".acf-map");
	if (acfmaps.length > 0) {
		acfmaps.forEach((acfmap) => {
			let map = document.querySelector('.map-wrapper');

			if (map) {
				let address = map.dataset.address;
				let marker = map.querySelector('.marker');
				if (address) {
					fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + address + '&key=AIzaSyDP1TIkHbQcGYN99s2ytBnn5nVfpTU0zHQ')
						.then(response => response.json())
						.then(data => {
							const latitude = data.results[0].geometry.location.lat;
							const longitude = data.results[0].geometry.location.lng;
							marker.dataset.lat = latitude;
							marker.dataset.lng = longitude;
							initMap(acfmap);
						})
				}
			} else {
				initMap(acfmap);
			}
		});
	}

	jQuery(document).on("sf:ajaxfinish", ".searchandfilter", function (e) {
		const acfmaps = document.querySelectorAll(".acf-map");

		acfmaps.forEach((acfmap) => {

			initMap(acfmap);
		});
	});
}

export default EventMap;
